import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {UserComposition} from 'containers/EditorPage';
import moment from 'moment';
import {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import useIndexedDB from 'utils/hooks/useIndexedDB';
import {Button, Modal} from 'letrus-ui';
import styles from './RecoverCompositionModal.module.scss';

export interface RecoverCompositionModalProps {
  id: string;
  onClose: () => void;
  onClickRestore: (localComposition: UserComposition) => void;
}

function RecoverCompositionModal({
  onClickRestore,
  onClose,
  id,
}: RecoverCompositionModalProps): JSX.Element {
  const {composition_id} = useParams();
  const [loading, setIsLoading] = useState(true);
  const [localCompositions, setLocalCompositions] =
    useState<UserComposition[]>();
  const localCompositionsIDB =
    useIndexedDB<UserComposition>('LocalCompositions');

  useEffect(() => {
    localCompositionsIDB
      .getAllSortedBy(composition_id, 'modified')
      .then((localCompositions) => {
        setLocalCompositions(localCompositions);
        setIsLoading(false);
      });
  }, []);

  return (
    <Modal id={id}>
      <div className={styles.wrapper}>
        {loading && (
          <div className={styles.spinner}>
            <FontAwesomeIcon icon="circle-notch" spin />

            <p>Carregando informações...</p>
          </div>
        )}

        <div className={styles.content}>
          <h3>Recuperar redação</h3>

          {localCompositions?.length ? (
            <div>
              <p>A seguir a lista de redações salvas.</p>

              {localCompositions.map((composition) => (
                <div
                  key={composition.modified}
                  className={styles.compositionBlock}
                >
                  <p>
                    <strong className="label">Data: </strong>
                    {moment(composition.modified).format('DD/MM/YYYY')}
                    <strong className="label"> Hora: </strong>
                    {moment(composition.modified).format('hh:mm')}
                  </p>
                  <p>
                    <strong className="label">Título: </strong>
                    {composition.title}
                  </p>
                  <p>
                    <strong className="label">Conteúdo: </strong>
                    {composition.text}
                  </p>
                  <div className={styles.useContentButton}>
                    <Button
                      theme="blue"
                      onClick={() => onClickRestore(composition)}
                    >
                      Usar este conteúdo
                    </Button>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div>
              <p>
                Não existe nenhuma versão anterior da sua redação para ser
                recuperada
              </p>
            </div>
          )}
        </div>

        <div className={styles.closeButton}>
          <Button variant="secondary" onClick={onClose}>
            Fechar
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default RecoverCompositionModal;
